import React from "react";
import { Link } from "react-router-dom";
import StoreButtons from "../ui/StoreButtons";
import Logo from "../../assets/images/logo/bigmall-logo.png";
import kokoLogo from "../../assets/images/logo/koko-90x41.png";
import topWeb from "../../assets/images/top-web.jpg";
import onePayLogo from "../../assets/images/logo/onepay-logo-150x150.png";
import cashOnDeliveryLogo from "../../assets/images/logo/cash-on-delivary-01-1_1-90x38.png";
import bigmallQRCode from "../../assets/images/footer-app-downloads/BIGMALL-QR-CODE.png";
import facebooklogo from "../../assets/images/logo/social-media/facebook.png";
import instagramlogo from "../../assets/images/logo/social-media/instagram.png";
import tiktoklogo from "../../assets/images/logo/social-media/tiktok.png";
import whatsapplogo from "../../assets/images/logo/social-media/whatsapp.png";

const socialLinks = [
  ["https://www.facebook.com/bigmall.lk", facebooklogo, "Facebook"],
  ["https://wa.me/94777961772", whatsapplogo, "WhatsApp"],
  ["https://www.instagram.com/bigmall.lk", instagramlogo, "Instagram"],
  ["https://www.tiktok.com/@bigmall.lk", tiktoklogo, "TikTok"],
];

const infoLinks = [
  ["/contact", "Contact Us"],
  ["/about-us", "About Us"],
  ["/track-order", "Track Order"],
  ["/terms-and-conditions", "Terms & Conditions"],
  ["/return-policy", "Refund & Returns Policy"],
  ["/privacy-policy", "Privacy Policy"],
];

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container container-lg">
        <div className="site-footer__grid">
          <div className="site-footer__brand">
            <Link to="/" className="d-inline-block">
              <img src={Logo} alt="Bigmall" className="site-footer__logo" />
            </Link>
            <ul className="site-footer__contact">
              <li>
                <i className="ph ph-phone-call" aria-hidden="true" />
                <a href="tel:+94777961772">Hotline: (+94) 777961772</a>
              </li>
              <li>
                <i className="ph ph-envelope-simple" aria-hidden="true" />
                <a href="mailto:info@bigmall.lk">info@bigmall.lk</a>
              </li>
            </ul>
            <div className="site-footer__social">
              {socialLinks.map(([href, icon, label]) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                  <img src={icon} alt="" width="32" height="32" />
                </a>
              ))}
            </div>
            <img src={topWeb} alt="TopWeb.lk award, June 2025" className="site-footer__award" />
          </div>

          <nav className="site-footer__col" aria-label="Information">
            <h3 className="site-footer__title">Information</h3>
            <ul className="site-footer__links">
              {infoLinks.map(([to, label]) => (
                <li key={to}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="site-footer__col">
            <h3 className="site-footer__title">We Accept</h3>
            <div className="site-footer__payments">
              <img src={cashOnDeliveryLogo} alt="Cash on delivery" />
              <img src={kokoLogo} alt="KOKO" />
              <img src={onePayLogo} alt="Onepay" />
            </div>
          </div>

          <div className="site-footer__col">
            <h3 className="site-footer__title">Get the App</h3>
            <div className="site-footer__app">
              <img src={bigmallQRCode} alt="Scan to download the Bigmall app" className="site-footer__qr ui-qr" />
              <StoreButtons compact className="site-footer__stores" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
